document.addEventListener("DOMContentLoaded", () => {
  const superSearch = document.querySelector(".super-search");
  const searchForm = superSearch.querySelector('form');
  const searchInput = searchForm.querySelector('input[type="search"]');
  const loader = superSearch.querySelector('form[action="/search"] .loader');
  const overlay = superSearch.querySelector(".overlay");
  const buttonClean = document.createElement("button");
  const historyContainer = superSearch.querySelector(".history-search");
  const sliderProducts = superSearch.querySelector('.super-search-products-slider');
  const htmlRoot = document.getElementsByTagName('html')[0];

  let searchResultsContainer, existingSuggestions, suggestionsContainer, searchTimeout, filterContainer;

  function addToSearchHistory(term) {
    let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    history = history.filter((item) => item !== term);
    history.unshift(term);
    history = history.slice(0, 5);
    localStorage.setItem("searchHistory", JSON.stringify(history));
    displaySearchHistory();
  }

  function removeFromSearchHistory(term) {
    let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    history = history.filter((item) => item !== term);
    localStorage.setItem("searchHistory", JSON.stringify(history));
    displaySearchHistory();
  }

  function clearSearchHistory() {
    localStorage.removeItem("searchHistory");
    displaySearchHistory();
  }

  function getCleanUrl() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    
    let localeSegment = pathSegments.find(segment => /^[a-z]{2}-[a-z]{2}$/.test(segment));
  
    if (!localeSegment) {
      localeSegment = pathSegments.find(segment => /^[a-z]{2}$/.test(segment));
    }

    return localeSegment ? `/${localeSegment}` : '';
  }

  function displaySearchHistory() {
    const history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    historyContainer.innerHTML = "";

    if (history.length > 0) {
      const title = document.createElement("h3");
      title.textContent = "Búsquedas recientes";
      historyContainer.appendChild(title);

      const list = document.createElement("ul");
      history.forEach((term) => {
        const item = document.createElement("li");
        const termSpan = document.createElement("span");
        termSpan.textContent = term;
        termSpan.addEventListener("click", () => {
          searchInput.value = term;
          if (historyContainer) historyContainer.classList.add("hidden");
          performSearch();
        });

        const deleteButton = document.createElement("button");
        deleteButton.textContent = "×";
        deleteButton.addEventListener("click", (e) => {
          e.stopPropagation();
          removeFromSearchHistory(term);
        });

        item.appendChild(termSpan);
        item.appendChild(deleteButton);
        list.appendChild(item);
      });
      historyContainer.appendChild(list);

      const clearButton = document.createElement("button");
      clearButton.textContent = "Borrar todo";
      clearButton.addEventListener("click", clearSearchHistory);
      historyContainer.appendChild(clearButton);
    }
  }

  function performSearch() {
    const searchTerm = searchInput.value.trim();
    const modifiedSearch = searchTerm.length >= 4 ? searchTerm.slice(0, -1) : searchTerm;
    const container = document.querySelector(".search-results-modal");
    if (modifiedSearch.length > 0) {
      setTimeout(() => {
        addToSearchHistory(modifiedSearch);
      }, 500);
        

      fetch(`${getCleanUrl()}/search?view=ajax&q=${encodeURIComponent(modifiedSearch)}`)
        .then((response) => response.text())
        .then((html) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          const searchPageContainer = tempDiv.querySelector(".search-page-container");
          if(window.innerWidth <= 1023){
             filterContainer = tempDiv.querySelector(".main-products-grid__filters");
          } 
                 
          if (searchPageContainer) {
            searchResultsContainer = document.getElementById("search-results-container");
            searchResultsContainer.innerHTML = searchPageContainer.innerHTML;

            if (window.innerWidth <= 1023) {
              superSearch.insertAdjacentHTML('afterbegin' , filterContainer.innerHTML);
            }

            container.classList.remove("hidden-with-animation");
            document.body.classList.add("overflow-hidden");
            htmlRoot.classList.add("overflow-hidden");
            searchInput.classList.add("clicked");
            document.body.classList.add("open-search-modal");

            overlay?.classList.add("hidden");

            fixProductImages(searchResultsContainer);
            
            history.pushState(
              { search: modifiedSearch }, "", `${window.Shopify.locale == 'es' ? '' : window.theme.routes.root.toLowerCase() }/search?q=${encodeURIComponent(modifiedSearch)}`
            );


            const closeBtn =
              searchResultsContainer.querySelector(".close-search");

            setTimeout(() => {
              if (closeBtn) {
                closeBtn.addEventListener("click", (event) => {
                  searchResultsContainer.classList.add("hidden-with-animation");
                  document.body.classList.remove("overflow-hidden");
                  htmlRoot.classList.remove("overflow-hidden");
                  document.body.classList.remove("open-search-modal");
                  window.history.pushState({}, document.title, `${getCleanUrl()}`, "");
                });
              }
            }, 1000);

            loader?.classList.add("hidden");
            buttonClean?.classList.add("show");
            document.dispatchEvent(
              new CustomEvent("searchComplete", { detail: { modifiedSearch } })
            );
          } else {
            console.error(
              "No se encontró el contenedor de resultados de búsqueda"
            );
            loader?.classList.add("hidden");
          }
        })
        .catch((error) => console.error("Error en la búsqueda:", error));
        


      fetch(`${getCleanUrl()}/search/suggest.json?q=${encodeURIComponent(modifiedSearch)}&resources[type]=collection&resources[limit]=5`)
      .then((response) => response.json())
      .then((suggestions) => {
        const collectionSuggestions = suggestions.resources.results.collections;
        displaySuggestions(collectionSuggestions, modifiedSearch);
    
        if (buttonClean) {
          buttonClean.innerText = "Borrar";
          buttonClean?.classList.add("button-clean-input");
          searchForm.querySelector(".search__form").appendChild(buttonClean);
          
          buttonClean.addEventListener("click", (btn) => {
            searchInput.value = "";

            window.history.pushState({}, document.title, `${getCleanUrl()}`, "");
            buttonClean.classList.remove("show");
            searchResultsContainer?.classList.add("hidden-with-animation");
            document.body.classList.remove("open-search-modal");
            
            if (suggestionsContainer) {
              suggestionsContainer.remove();
            }
            if (sliderProducts) sliderProducts.classList.remove('hidden', 'collapse');
            historyContainer.classList.remove('hidden' , 'collapse');
            displaySearchHistory();
          });
        }
      })
      .catch((error) => console.error("Error en las sugerencias:", error));
    }
  }

  searchInput.addEventListener("click", () => {
    const searchContainer = document.querySelector(".search-results-modal");
    if (searchInput.classList.contains("clicked") && searchContainer) {
      document.body.classList.add("open-search-modal");
      document.body.classList.add("overflow-hidden");
      htmlRoot.classList.add("overflow-hidden");
      searchContainer.classList.remove("hidden-with-animation");
      if (historyContainer && !suggestionsContainer)
        historyContainer.classList.remove("hidden");
    }
  });

  function displaySuggestions(suggestions, modifiedSearch) {
    if (!suggestions && suggestions.length <= 0) return;

    suggestionsContainer = document.createElement("div");
    suggestionsContainer?.classList.add("search-suggestions");

    if (searchInput && suggestionsContainer) {
      searchInput.addEventListener("click", () => {
        suggestionsContainer.classList.remove("hidden");
      });
    }

    if (suggestions.length > 0) {
      const suggestionsList = document.createElement("ul");
      suggestions.slice(0, 5).forEach((suggestion) => {
        const item = document.createElement("li");
        item.innerHTML = highlightMatch(suggestion.title, modifiedSearch);
        item.addEventListener("click", () => {
          searchInput.value = suggestion.title;
          performSearch();
        });
        suggestionsList.appendChild(item);
      });
      suggestionsContainer.appendChild(suggestionsList);
    }

    existingSuggestions = searchForm.querySelector(".search-suggestions");
    if (existingSuggestions) {
      existingSuggestions.remove();
    }

    searchForm.appendChild(suggestionsContainer);
  }

  function highlightMatch(text, modifiedSearch) {
    const regex = new RegExp(`(${escapeRegExp(modifiedSearch)})`, "gi");
    return text.replace(regex, "<strong>$1</strong>");
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function fixProductImages(container) {
    const productCards = container.querySelectorAll(".product-card, .card--product");
    productCards.forEach((card) => {
      const images = card.querySelectorAll("img[data-srcset]");
      images.forEach((img, index) => {
        const srcset = img.getAttribute("data-srcset");
        if (srcset) {
          const sources = srcset
            .split(",")
            .map((src) => src.trim().split(" ")[0]);
          if (sources.length > 0) {
            img.setAttribute("src", sources[0]);

            if (sources.length > 1) {
              img.setAttribute("srcset", sources[0]);
              img.classList.add("lazyload");

              const newSrcset = sources
                .map((src, i) => `${src} ${(i + 1) * 200}w`)
                .join(", ");
              img.setAttribute("srcset", newSrcset);
            }
          }
        }
      });
    });

    if (typeof lazySizes !== "undefined") {
      lazySizes.init();
    }
  }

  searchInput.addEventListener("input", function (event) {
    if (buttonClean) buttonClean.classList.remove("show");
    if (historyContainer) historyContainer.classList.add("hidden");
    if (suggestionsContainer) suggestionsContainer.classList.remove("hidden");
    if (sliderProducts) sliderProducts.classList.add('hidden');
    if (searchInput.value.length > 0) {
      clearTimeout(searchTimeout);
      loader?.classList.remove("hidden");
      searchTimeout = setTimeout(performSearch, 300);
    } else {
      if (historyContainer) historyContainer.classList.remove("hidden");
      if (suggestionsContainer) suggestionsContainer.classList.add("hidden");
      if (sliderProducts) sliderProducts.classList.remove('hidden');
      loader.classList.add("hidden");
      displaySearchHistory();
    }
  });

  searchForm.addEventListener("submit", function (event) {
    event.preventDefault();
    performSearch();
  });

  displaySearchHistory();
});